export default "__VITE_ASSET__BOUv3Tgv__"